export default {
  performance: {
    listTitleTable: {
      TICKER: 'MÃ',
      PRICE: 'GIÁ',
      PERCENT_PRICE_CHANGE_1DAY: '1 Ngày',
      PERCENT_PRICE_CHANGE_1WEEK: '1 Tuần',
      PERCENT_PRICE_CHANGE_2WEEK: '2 Tuần',
      PERCENT_PRICE_CHANGE_1MONTH: '1 Tháng',
      PERCENT_PRICE_CHANGE_3MONTH: '3 Tháng',
      PERCENT_PRICE_CHANGE_6MONTH: '6 Tháng',
      PERCENT_PRICE_CHANGE_9MONTH: '9 Tháng',
      PERCENT_PRICE_CHANGE_1YEAR: '1 Năm',
      PERCENT_PRICE_CHANGE_YTD: 'Tính đến hiện tại',
    },
  },
  overview: {
    overviewHeader: {
      TICKER: 'MÃ',
      PRICE: 'GIÁ',
      CHANGE_PRICE: 'THAY ĐỔI',
      PERCENT_PRICE_CHANGE: '% THAY ĐỔI',
      VOLUME: 'KHỐI LƯỢNG',
      AVG_VOLUME: 'KL TB',
      RTD11: 'VỐN HÓA (Tỷ)',
      RANKING: 'XẾP HẠNG',
      PB: 'P/B',
      PE: 'P/E',
    },
  },
  financial: {
    financialHeader: {
      TICKER: 'MÃ',
      PRICE: 'GIÁ',
      PERCENT_PRICE_CHANGE: '% THAY ĐỔI',
      ISA3: 'DOANH THU (Tỷ) (TTM) ',
      ISA20: 'LỢI NHUẬN RÒNG (Tỷ) (TTM)',
      RTD14: 'EPS (TTM)',
      RTD7: 'BVPS (VND)',
      RTD21: 'P/E',
      RTD25: 'P/B',
    },
  },
  technical: {
    technicalHeader: {
      TICKER: 'MÃ',
      VOLUME: 'KHỐI LƯỢNG',
      PRICE: 'GIÁ',
      PERCENT_PRICE_CHANGE: '% THAY ĐỔI',
      SMA20: 'SMA20',
      SMA50: 'SMA50',
      SMA100: 'SMA100',
      RSI: 'RSI',
      CANDLE_STICK: 'MÔ HÌNH NẾN',
    },
  },

  timeRangeList: {
    OneWeek: '5 Ngày',
    TwoWeeks: '10 Ngày',
    OneMonth: '20 Ngày',
  },

  rateList: {
    OnePointTwo: '1.2',
    OnePointFive: '1.5',
    Two: '2',
    Five: '5',
    Ten: '10',
  },

  filterContent: {
    part_1: 'Tỷ lệ giữa KLGD hiện tại và KLGDTB trong',
    part_2: 'Lớn hơn',
    part_3: 'Lần',
    apply: 'ÁP DỤNG',
  },
};
